import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { CountryDropdown } from "react-country-region-selector";
import { setAlert } from "../../../actions/alertActions";
import {
  getCountryName,
  compressImage,
  getCountryCode,
} from "../../utils/Utils";
import "../../../styles/components/evs/modals/ActionCardUser.scss";
import evsPlaceholder from "../../../styles/images/evsPlaceholder.svg";
import camera from "../../../styles/images/camera.svg";

import LoadingSpinner from "../../utils/components/LoadingSpinner";

class ActionCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isScrolled: false,

      evPicture: evsPlaceholder,
      types: [],

      plate: "",
      brand: "",
      model: "",
      country: getCountryName(this.props.country) || "",
      otherInfo: "",
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    //this.fetchOtherEVTypes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.show &&
      this.props.mode === "add" &&
      prevProps.mode !== "add"
    ) {
      this.safeSetState({
        validated: false,
        isScrolled: false,
        evPicture: evsPlaceholder,
        plate: "",
        brand: "",
        model: "",
        country: getCountryName(this.props.country) || "",
        otherInfo: "",
      });
    }
    if (
      this.props.hasOwnProperty("selectedEV") &&
      this.props.selectedEV &&
      this.props.selectedEV.evType !== "car"
    ) {
      if (
        prevProps.selectedEV !== this.props.selectedEV ||
        prevProps.selectedEV.evId !== this.props.selectedEV.evId
      ) {
        const { selectedEV } = this.props;

        this.safeSetState({
          evPicture: selectedEV.imageContent,
          plate: selectedEV.licensePlate,
          brand: selectedEV.brand,
          model: selectedEV.model,
          country: selectedEV.country,
          otherInfo: selectedEV.otherInfo,
        });
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchOtherEVTypes(callback) {
    axios
      .get("/api/private/otherEvs", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ types: res.data }, callback);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    const file = e.target.files && e.target.files[0];

    compressImage(file).then((evPicture) => {
      this.safeSetState({ evPicture });
    });
  }

  handleOnChange(e) {
    const { name, value } = e.target;
    this.safeSetState({
      [name]: value,
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.toggleLoadingActionCards(true);
        const { plate, brand, model } = form.elements;
        this.props.mode === "add"
          ? this.props.onSubmit(
              this.state.evPicture !== evsPlaceholder
                ? this.state.evPicture
                : "",
              plate.value,
              "TYPECARD",
              model.value,
              this.state.country,
              this.state.otherInfo
            )
          : this.props.onSubmit(
              this.props.selectedEV,
              this.state.evPicture !== evsPlaceholder
                ? this.state.evPicture
                : "",
              plate.value,
              "TYPECARD",
              model.value,
              this.state.country,
              this.state.otherInfo
            );
      }
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
      isScrolled: false,

      evPicture: evsPlaceholder,

      plate: "",
      brand: "",
      model: "",
      country: getCountryName(this.props.country) || "",
      otherInfo: "",
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="addOtherEV"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate
              value={this.props.mode === "add" ? "evs_addCard" : "evs_editCard"}
            />
          </Modal.Title>
        </Modal.Header>
        <div
          className={
            "picture-picker-container " +
            (this.state.isScrolled ? "shadowed" : "")
          }
        >
          <input
            id="file-picker"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={this.handlePictureChange}
          />
          <button
            type="button"
            className="picture-picker"
            onClick={this.handlePickPicture}
          >
            <img
              id="picture"
              src={this.state.evPicture || evsPlaceholder}
              onError={(e) => (e.target.src = evsPlaceholder)}
              alt={
                this.state.evPicture !== evsPlaceholder
                  ? "EV picture"
                  : "placeholder"
              }
            />
            <img src={camera} className="camera" alt="" />
          </button>
        </div>
        <Modal.Body onScroll={this.handleScroll}>
          <Form
            id="add-card-form"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
            className="ev-properties"
          >
            <Form.Group className="form-field plate" controlId="evPlate">
              <Form.Label>
                <Translate value="evs_specificDesignation" />
              </Form.Label>
              <Form.Control
                type="text"
                name="plate"
                value={this.state.plate}
                onChange={this.handleOnChange}
                placeholder="1"
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidPlate" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field brand" controlId="evType">
              <Form.Label>
                <Translate value="evs_typeCard" />
              </Form.Label>
              <Form.Control
                type="text"
                name="brand"
                value={I18n.t("TYPECARD")}
                disabled
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidBrand" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field model" controlId="evModel">
              <Form.Label>
                <Translate value="evs_generalDesignation" />
              </Form.Label>
              <Form.Control
                type="text"
                name="model"
                value={this.state.model}
                onChange={this.handleOnChange}
                placeholder={I18n.t("myEvs_visitors")}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_cardDesignation" />
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group
              className="form-field country-field"
              controlId="evCountry"
            >
              <Form.Label>
                <Translate value="evs_country" />
              </Form.Label>
              <Form.Control
                as={CountryDropdown}
                value={this.state.country}
                onChange={(country) => this.safeSetState({ country })}
              ></Form.Control>
            </Form.Group>

            <Form.Group className="form-field otherInfo" controlId="otherInfo">
              <Form.Label>
                <Translate value="myEvs_additionalInfo" />
              </Form.Label>
              <textarea
                name="otherInfo"
                value={this.state.otherInfo}
                placeholder={I18n.t("myEvs_typeHere")}
                onChange={this.handleOnChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {this.props.loading === true ? (
            <LoadingSpinner />
          ) : (
            <button type="submit" form="add-card-form">
              <Translate
                value={
                  this.props.mode === "add" ? "evs_addCard" : "evs_editCard"
                }
              />
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, { setAlert })(ActionCard);
